module.exports = __webpack_public_path__ + "static/media/actor-close.d0ec55d6.svg";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/actor-close.svg
// module id = 1962
// module chunks = 0